import { useCallback, useEffect, useRef } from 'react';

// Типы для Taddy SDK (window.Taddy)
interface TaddyAds {
  interstitial: (params: {
    payload?: Record<string, any>;
    onClosed?: () => void;
    onViewThrough?: (id: string) => void;
  }) => Promise<boolean>;
}

interface TaddySDK {
  init: (pubId: string) => void;
  ready: () => void;
  ads: () => TaddyAds;
}

declare global {
  interface Window {
    Taddy?: TaddySDK;
  }
}

interface UseTaddyParams {
  pubId: string;
  onReward: (adId: string) => void;
  onError?: (error: string) => void;
}

export function useTaddy({ pubId, onReward, onError }: UseTaddyParams) {
  const initializedRef = useRef(false);

  useEffect(() => {
    // SDK с data-pub-id автоматически вызывает init() и ready()
    // Но на случай если нужно вручную — проверяем
    if (window.Taddy && !initializedRef.current) {
      initializedRef.current = true;
    }
  }, [pubId]);

  const showAd = useCallback(async () => {
    if (!window.Taddy) {
      onError?.('Taddy script not loaded');
      return;
    }

    try {
      const ads = window.Taddy.ads();
      await ads.interstitial({
        payload: { source: 'moonraid' },
        onViewThrough: (id: string) => {
          // Юзер досмотрел рекламу — вызываем reward
          onReward(id);
        },
        onClosed: () => {
          // Юзер закрыл рекламу (не досмотрел) — ничего не делаем
        },
      });
    } catch (err: any) {
      onError?.(err?.message || 'Taddy ad error');
    }
  }, [onReward, onError]);

  return showAd;
}
